/* eslint-disable camelcase */
/* eslint-disable import/order */
import React from 'react'
import { Box, Grid } from '@material-ui/core'
import '../../../../resources/less/fullCalendar.less'
import StyledCheckBox from '../../../../components/hooks/BaseCheckBox'
import { CollectTypeBadge, getCollectType } from '../CollectTypeBadge'

export const UnbookedCard = ({
  event,
  checkeds = [],
  handleChecked = id => {},
}) => {
  if (!event) return null

  const {
    service = {},
    id,
    client = {},
    vendedor = {},
    bar_code = null,
    final_time = null,
    attendant = '',
    schedulingInformation = {},
    collect_type = null,
  } = event

  const renderLatLng = client?.coordinates?.lat || client?.coordinates?.lng
  const renderNeighborhood = client?.neighborhood || client?.bairro
  const collectType =
    collect_type || getCollectType(service?.attendanceType, bar_code)

  return (
    <Grid
      item
      xs={12}
      container
      spacing={1}
      key={id}
      className="fc-event"
      title={service?.name}
      textColor="#000"
      id={id}
      duration={final_time}
      attendant={attendant}
      client_name={client.name || 'Não definido'}
      schedulingInformation={schedulingInformation}
      unbookedService="true"
      unbookedBgColor={service?.color}
      neighborhood={client?.neighborhood || client?.bairro}
      lat={client?.coordinates?.lat || ''}
      lng={client?.coordinates?.lng || ''}
      service={service?.name}
      client={client?.name}
      vendedor={vendedor?.name}
      bar_code={bar_code}
      collect_type={collectType || ''}
      style={{ minHeight: '80px', position: 'relative' }}
    >
      {collectType && (
        <CollectTypeBadge
          type={collectType}
          variant="outlined"
          style={{
            position: 'absolute',
            top: 8,
            right: 8,
            zIndex: 1,
            color: '#646464 !important',
            border: '1px solid #F1F1F1',
          }}
        />
      )}

      <Grid
        item
        className="fc-event-indicator"
        style={{
          backgroundColor: service?.color,
        }}
      />

      <Grid item xs={2} className="fc-event-checkbox">
        <StyledCheckBox
          checked={checkeds.indexOf(id) > -1}
          onChange={handleChecked}
          name={`${id}`}
        />
      </Grid>

      <Grid item xs>
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
            alignItems: 'flex-start',
            justifyContent: 'center',
            height: '100%',
          }}
        >
          <span hidden={!renderLatLng}>
            {`Coordenada: ${client?.coordinates?.lat},${client?.coordinates?.lng}`}
          </span>
          <span hidden={!renderNeighborhood}>
            {`Bairro: ${client?.neighborhood || client?.bairro}`}
          </span>
          <span>{`Item: ${service?.name}`}</span>
          <span>{`Cliente: ${client?.name}`}</span>
          <span hidden={!vendedor?.name}>{`Vendedor: ${vendedor?.name}`}</span>
          <span hidden={!bar_code}>{`Etiqueta: ${bar_code}`}</span>
        </Box>
      </Grid>
    </Grid>
  )
}
